import React from 'react'
// import "../Styles/Tour_information.css"
import { NavLink, Outlet } from 'react-router-dom'

function Tour_information() {
  return (
    <div className='tourInfo_container'>
      <h2 className='tourInfo_title'>Destination Wedding Information</h2>
      <div className='tourInfo_card'>
        <div className='tourInfo_section_navber' style={{overflowX:"auto"}}>
          <NavLink to={"/profile/destination-wedding"} end className={({ isActive }) => 
              isActive ? "tourInfo_link active" : "tourInfo_link" 
            }>
             Upcoming
          </NavLink>
          <NavLink to={"/profile/destination-wedding/past"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
             Past
          </NavLink>
        </div>
        <hr/>

        <div>
          <Outlet/>
        </div>
        </div>
    </div>
  )
}

export default Tour_information